import React from 'react';
import {
  Paper,
  Button,
  Divider,
  FormControl,
  Box,
  Alert,
  Snackbar
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import {
  useNavigate,
  useLocation,
  useParams
} from "react-router-dom";
import {TextField} from '../../components';
import api from "../../services/api";
import { useStoreActions } from 'easy-peasy';
yup.setLocale(pt);

const ConfirmaUsuario = () => {
  let params = useParams();
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  let setUser = useStoreActions((actions) => actions.auth.setUser);

  let navigate = useNavigate();
  let location = useLocation();

  let from = location.state?.from?.pathname || "/";

  const schema = yup.object({
    password: yup.string()
      .label('Nova senha').required(),
    confirmPassword: yup.string()
      .label('Confirmar nova senha').required()
      .oneOf([yup.ref('password')],
             'A confirmação da senha deve ser igual a nova senha'),
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const { handleSubmit } = useFormRef;

  const onSubmit = async (data) => {
    startLoading();
    try {
      await api.http.post('/reset-password/',{...data,hash:params.hash});
      stopLoading({ severity: 'success' });
      navigate('/login', { replace: true });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  };

  return (
    <Paper variant="outlined" className='center-box' sx={{
      textAlign: 'center',
      px: 4,
      pt: 2,
      pb: 3,
      m: 5,
      maxWidth: 'sm',
    }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Divider>
          <h3>Confirma Usuário</h3>
        </Divider>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField field="password" type="password"
                     useFormRef={useFormRef} schema={schema} />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField field="confirmPassword" type="password"
                     useFormRef={useFormRef} schema={schema} />
        </FormControl>
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" size="large"
                  endIcon={<ArrowForwardIcon />} >Alterar minha senha</Button>
        </Box>
      </form>
    </Paper>
  );
};

export default ConfirmaUsuario;
